import { backendApi } from "@/services/api";
import { AirSampler } from "./air-sampler";

const airSamplersApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    listAirSamplers: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/air-samplers`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["AirSamplers"],
    }),
    getAirSampler: build.query<AirSamplerResponse, GetRequest>({
      query: (request) => ({
        url: `/air-samplers/{${request.id}`,
        method: "GET",
      }),
      providesTags: (_result, _e, request) => [
        { type: "AirSamplers", id: request.id },
      ],
    }),
    putAirSampler: build.mutation<AirSamplerResponse, PutRequest>({
      query: (request) => ({
        url: `/air-samplers`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["AirSamplers"],
    }),
    deleteAirSampler: build.mutation<DeleteResponse, DeleteRequest>({
      query: (request) => ({
        url: `/air-samplers`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["AirSamplers"],
    }),
  }),
});

export const {
  useListAirSamplersQuery,
  useGetAirSamplerQuery,
  usePutAirSamplerMutation,
  useDeleteAirSamplerMutation,
} = airSamplersApi;

export interface PutRequest {
  airSampler: AirSampler;
}

export interface GetRequest {
  id: string;
}

export interface AirSamplerResponse {
  airSampler: AirSampler;
}

export interface ListRequest {
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: AirSampler[];
}

export interface DeleteRequest {
  id: string;
}

export interface DeleteResponse {}
